import { applyMiddleware, combineReducers, compose, createStore, Middleware, Reducer, ReducersMapObject } from 'redux'
import immutableStateInvariant from 'redux-immutable-state-invariant'
import { createLogger } from 'redux-logger'
import { Epic } from 'redux-observable'

import { actionToPlainObject, createInjectableEpics, createInjectableStore } from 'modules/store'

import { IS_DEV } from '../../environment'
import { isObjectLike } from '../shared'

const composeEnhancers = (IS_DEV && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose

const createEpics = (initialEpics: Array<Epic<any, any>> = [], initialProviders: {} = {}) => {
  return createInjectableEpics(initialEpics, initialProviders)
}
const createAppStore = (
  initialState: {},
  initialStore?: null | Array<{
    id: string
    reducers: Reducer<any> | ReducersMapObject
  }>,
  middleware: Middleware[] = []
) => {
  const enhancers = getMiddleware(middleware)
  const store = createInjectableStore(initialState, enhancers)

  if (initialStore) {
    initialStore.forEach((storeConfig) => {
      store.inject(storeConfig.id, storeConfig.reducers)
    })
  }

  return store
}

const getMiddleware = (customMiddlewares: Middleware[] = []) => {
  const middleware = IS_DEV
    ? [
        actionToPlainObject,
        // - Enable additional logging
        createLogger({ collapsed: true }),
        // - Enable state immutability checker
        immutableStateInvariant(),
        ...customMiddlewares,
      ]
    : [actionToPlainObject as any, ...customMiddlewares]

  return composeEnhancers(applyMiddleware(...middleware))
}

/**
 * Util helper for creating store within TESTS ( not lazy loaded stores/epics )
 * @param state
 * @param reducers
 */
function createStoreWithState(state = {}, reducers: Reducer<any> | ReducersMapObject) {
  const rootReducer = isObjectLike(reducers) ? combineReducers({ core: (s = {}) => s }) : reducers

  return createStore(rootReducer, state, getMiddleware())
}

export { createAppStore as createStore, createEpics, createStoreWithState }



// WEBPACK FOOTER //
// ./src/app/core/store.config.ts